import { Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Footer from '../Components/Footer';
import OrganizerHeader from '../Components/OrganizerHeader';

/// These styles ensure the footer stays at the bottom of the page
const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
`;

const OrganizerLayout = () => {
  const location = useLocation();

  // Define routes where you DON'T want header/footer
  const hiddenLayoutRoutes = ['/organizers', '/organizers/', '/organizers/select-court'];
  const hideHeaderFooter = hiddenLayoutRoutes.includes(location.pathname);

  return (
    <PageWrapper>
      {!hideHeaderFooter && <OrganizerHeader />}
      <Main>
        <Outlet />
      </Main>
      {!hideHeaderFooter && <Footer />}
    </PageWrapper>
  );
};

export default OrganizerLayout;
